<aside class="menu mt-2 ml-5 is-hidden-mobile">
  @for (item of MenuItems; track item) {
    <div>
      <p class="menu-label mb-1 mt-4">
        {{item.Text}}
      </p>
      <ul class="menu-list">
        @for (subitem of item.Children; track subitem) {
          <li class="m-0 p-0" [ngStyle]="{'opacity' : subitem.Enabled ? 1 : 0.4, 'pointer-events': subitem.Enabled ? 'auto' : 'none' }">
            <a [routerLink]="'/' + subitem.Route">{{subitem.Text}}</a>
          </li>
        }
      </ul>
    </div>
  }
</aside>